export default {
    faqs: [
        {
            "id": 72000052361,
            "name": "About the App",
            "description": null,
            "visibility": 1,
            "created_at": "2021-10-20T00:16:23Z",
            "updated_at": "2021-10-22T01:06:25Z",
            "articles": [
                {
                    "id": 72000091192,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:10:02Z",
                    "category_id": 72000035784,
                    "folder_id": 72000052361,
                    "title": "Who is this app meant for?",
                    "updated_at": "2021-10-22T01:10:03Z",
                    "description": "<p>Does somebody always know if you made it home last night? If not, this app can help notify others when you don't.&nbsp;</p><p dir=\"ltr\">For those who live alone, have others in their care, or just want to add an extra layer of security to their lives - we hope to help.</p><p><br></p>",
                    "description_text": " Does somebody always know if you made it home last night? If not, this app can help notify others when you don't.   For those who live alone, have others in their care, or just want to add an extra layer of security to their lives - we hope to help.    ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000104368,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-26T02:27:14Z",
                    "category_id": 72000035784,
                    "folder_id": 72000052361,
                    "title": "What makes I'm Okay different from similar apps?",
                    "updated_at": "2022-02-15T05:45:37Z",
                    "description": "<p dir=\"ltr\">Luckily for all of us, there are great apps and services available to help add safety measures to our everyday lives. While each meets different needs, there are a few services very similar to I'm Okay in that they use text messages (instead of apps) to facilitate contact.</p><p dir=\"ltr\"><strong dir=\"ltr\">So, what makes I'm Okay different?</strong></p><ul><li dir=\"ltr\">Flexible schedules for your check-in messages. From once per week to 3 times daily, at times you choose that fit your lifestyle.<br><br></li><li dir=\"ltr\">The ability to relay important information to your emergency contacts by including emergency notes that will be sent to your contacts should you fail to check-in. These can include:<ul><li dir=\"ltr\">Medical Information</li><li dir=\"ltr\">Child and Family Care</li><li dir=\"ltr\">Pet and Property Care</li><li dir=\"ltr\">And more!<br><br></li></ul></li><li dir=\"ltr\">You can easily add 1-time check-ins for special circumstances, like first dates and other stranger dangers.<br><br></li><li dir=\"ltr\">You can snooze your check-ins so you don't have to worry about them while you're on vacation or otherwise un-plugged. Your check-ins will resume automatically afterward.<br><br></li><li dir=\"ltr\">You can manage your settings via web app and even through text messages if you're away from your computer or smartphone.</li></ul><p dir=\"ltr\"><br></p><p dir=\"ltr\">I'mOkay.me is free for 20-days, no credit card required. <a href=\"/signup\">Sign-up now </a>and try it for yourself to see how we stack up against others!</p>",
                    "description_text": " Luckily for all of us, there are great apps and services available to help add safety measures to our everyday lives. While each meets different needs, there are a few services very similar to I'm Okay in that they use text messages (instead of apps) to facilitate contact.  So, what makes I'm Okay different?   Flexible schedules for your check-in messages. From once per week to 3 times daily, at times you choose that fit your lifestyle.    The ability to relay important information to your emergency contacts by including emergency notes that will be sent to your contacts should you fail to check-in. These can include:  Medical Information  Child and Family Care  Pet and Property Care  And more!      You can easily add 1-time check-ins for special circumstances, like first dates and other stranger dangers.    You can snooze your check-ins so you don't have to worry about them while you're on vacation or otherwise un-plugged. Your check-ins will resume automatically afterward.    You can manage your settings via web app and even through text messages if you're away from your computer or smartphone.      I'mOkay.me is free for 20-days, no credit card required. Sign-up now and try it for yourself to see how we stack up against others! ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 1,
                    "feedback_count": 0
                },
                {
                    "id": 72000514015,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-06T04:20:00Z",
                    "category_id": 72000035784,
                    "folder_id": 72000052361,
                    "title": "Is I'mOkay.me available in other countries outside the US?",
                    "updated_at": "2022-01-06T04:20:00Z",
                    "description": "<p dir=\"ltr\">Yes, you can use I'mOkay.me outside the US as long as your mobile carrier allows the sending and receiving of text messages from our numbers.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">We plan to offer more localized international numbers in the future.</p>",
                    "description_text": " Yes, you can use I'mOkay.me outside the US as long as your mobile carrier allows the sending and receiving of text messages from our numbers.     We plan to offer more localized international numbers in the future. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000514017,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-06T04:21:05Z",
                    "category_id": 72000035784,
                    "folder_id": 72000052361,
                    "title": "Is I'mOkay.me available in any other languages?",
                    "updated_at": "2022-02-11T01:39:57Z",
                    "description": "<p dir=\"ltr\">English is the only supported language at this time. We are working to provide a Spanish version of the service in the near future, followed by other languages depending on demand.</p>",
                    "description_text": " English is the only supported language at this time. We are working to provide a Spanish version of the service in the near future, followed by other languages depending on demand. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        },
        {
            "id": 72000052360,
            "name": "Signing-Up",
            "description": null,
            "visibility": 1,
            "created_at": "2021-10-20T00:16:23Z",
            "updated_at": "2021-10-22T01:06:42Z",
            "articles": [
                {
                    "id": 72000091194,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:24:26Z",
                    "category_id": 72000035784,
                    "folder_id": 72000052360,
                    "title": "What information is required from me to start using I'm Okay?",
                    "updated_at": "2022-01-07T07:41:09Z",
                    "description": "<p dir=\"ltr\">Just four items are required to get started:</p><ul><li dir=\"ltr\"><strong>Your name <br></strong>Can just be your first name or nickname.<br><br></li><li dir=\"ltr\"><strong>Your phone number<br></strong>Used to send your check-ins to.<br><br></li><li dir=\"ltr\"><strong>Your email address <br></strong>Used to provide account access to the web/mobile apps.<br><br></li><li dir=\"ltr\"><strong dir=\"ltr\">An Emergency Contact</strong><br>Someone who can be notified if you fail to respond to a check-in.</li></ul><p dir=\"ltr\"><br></p><p dir=\"ltr\">You'll want to add at least one emergency contact that can be reached by text message.&nbsp;</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Everything else is optional, although we recommend providing some emergency notes to help others help you.</p>",
                    "description_text": " Just four items are required to get started:   Your name  Can just be your first name or nickname.    Your phone number Used to send your check-ins to.    Your email address  Used to provide account access to the web/mobile apps.    An Emergency Contact Someone who can be notified if you fail to respond to a check-in.      You'll want to add at least one emergency contact that can be reached by text message.      Everything else is optional, although we recommend providing some emergency notes to help others help you. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        },
        {
            "id": 72000327737,
            "name": "Check-Ins",
            "description": null,
            "visibility": 1,
            "created_at": "2022-01-07T07:33:15Z",
            "updated_at": "2022-01-07T07:33:15Z",
            "articles": [
                {
                    "id": 72000091205,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:12:37Z",
                    "category_id": 72000035784,
                    "folder_id": 72000327737,
                    "title": "How can I \"Snooze\" my check-ins?",
                    "updated_at": "2022-01-07T07:39:51Z",
                    "description": "<p dir=\"ltr\">Easy! You can temporarily disable your check-ins via the following methods:</p><ul><li dir=\"ltr\">Using the I'm Okay app.</li><li dir=\"ltr\">Sending \"snooze X\" to I'm Okay, where \"X\" is the number of days you wish to snooze your check-ins.</li></ul>",
                    "description_text": " Easy! You can temporarily disable your check-ins via the following methods:   Using the I'm Okay app.  Sending \"snooze X\" to I'm Okay, where \"X\" is the number of days you wish to snooze your check-ins.  ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000514336,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-07T07:34:49Z",
                    "category_id": 72000035784,
                    "folder_id": 72000327737,
                    "title": "How often can I receive check-in messages?",
                    "updated_at": "2022-01-07T07:34:49Z",
                    "description": "<p dir=\"ltr\">You can receive up to 3 check-in text messages per day.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Messages can be scheduled for any and every day of the week, at the times you choose as best for receiving them.</p>",
                    "description_text": " You can receive up to 3 check-in text messages per day.     Messages can be scheduled for any and every day of the week, at the times you choose as best for receiving them. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091220,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:13:47Z",
                    "category_id": 72000035784,
                    "folder_id": 72000327737,
                    "title": "How can I send a 1-time check-in?",
                    "updated_at": "2022-01-07T07:39:37Z",
                    "description": "<p dir=\"ltr\">One-time check-ins can be scheduled via the Dashboard of the I'm Okay app, under the \"Tools\" section.</p>",
                    "description_text": " One-time check-ins can be scheduled via the Dashboard of the I'm Okay app, under the \"Tools\" section. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000514337,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-07T07:38:47Z",
                    "category_id": 72000035784,
                    "folder_id": 72000327737,
                    "title": "When should I schedule my check-in messages?",
                    "updated_at": "2022-01-07T07:38:47Z",
                    "description": "<p dir=\"ltr\">You should schedule your check-ins to be sent at times you're most likely to be able to respond to them.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">You'll want to make sure these are times that you are typically awake and have your phone close by. Most users schedule their check-ins during the morning or in the early evenings.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Some users disable their check-ins during weekends as their schedules may be less routine.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">While you have an hour (or more, if you choose) to respond to your check-ins, you'll want to carefully choose your check-in schedule as to not needlessly alarm your emergency contacts should you fail to respond for non-emergent reasons.</p>",
                    "description_text": " You should schedule your check-ins to be sent at times you're most likely to be able to respond to them.     You'll want to make sure these are times that you are typically awake and have your phone close by. Most users schedule their check-ins during the morning or in the early evenings.     Some users disable their check-ins during weekends as their schedules may be less routine.     While you have an hour (or more, if you choose) to respond to your check-ins, you'll want to carefully choose your check-in schedule as to not needlessly alarm your emergency contacts should you fail to respond for non-emergent reasons. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        },
        {
            "id": 72000058089,
            "name": "Emergency Contacts",
            "description": null,
            "visibility": 1,
            "created_at": "2021-10-22T01:07:16Z",
            "updated_at": "2021-10-22T01:07:16Z",
            "articles": [
                {
                    "id": 72000091195,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:26:43Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058089,
                    "title": "What are \"Emergency Contacts\"?",
                    "updated_at": "2021-10-22T01:26:43Z",
                    "description": "<p dir=\"ltr\">Your emergency contacts are the people you designate to receive alerts should you fail to respond to one of our check-ins within the timeframe you've chosen (by default, 1 hour after your check-in has been sent).</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Many users include a family member, a friend, and even co-workers if they're living far away from the former.</p>",
                    "description_text": " Your emergency contacts are the people you designate to receive alerts should you fail to respond to one of our check-ins within the timeframe you've chosen (by default, 1 hour after your check-in has been sent).     Many users include a family member, a friend, and even co-workers if they're living far away from the former. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091196,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:28:18Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058089,
                    "title": "How many Emergency Contacts can I have?",
                    "updated_at": "2021-10-22T01:28:18Z",
                    "description": "<p dir=\"ltr\">You can have up to 4 active emergency contacts at any time.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">I'm Okay lets you add up to 4 contacts in total, allowing you to switch which contacts are active (e.g. will receive alerts) depending on who you choose to rely on at any given time.</p>",
                    "description_text": " You can have up to 4 active emergency contacts at any time.     I'm Okay lets you add up to 4 contacts in total, allowing you to switch which contacts are active (e.g. will receive alerts) depending on who you choose to rely on at any given time. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091197,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:30:57Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058089,
                    "title": "Will my Emergency Contacts be notified when I add them?",
                    "updated_at": "2021-10-22T01:30:57Z",
                    "description": "<p dir=\"ltr\">Yes. They will receive a text notification explaining they've been added as an emergency contact for you. This notification will include your name and phone number to add validity to the message.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">It's always helpful to provide a head's-up to your contacts before adding them so they do not find the notification to be spam and unsubscribe.</p>",
                    "description_text": " Yes. They will receive a text notification explaining they've been added as an emergency contact for you. This notification will include your name and phone number to add validity to the message.     It's always helpful to provide a head's-up to your contacts before adding them so they do not find the notification to be spam and unsubscribe. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091198,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:33:45Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058089,
                    "title": "What happens if one of my Emergency Contacts opts out of receiving messages from I'm Okay?",
                    "updated_at": "2021-12-29T02:43:33Z",
                    "description": "<p dir=\"ltr\">You will be sent a text notification informing you of the contact who has opted-out (e.g. replied \"stop\" to one of our notifications).</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Should this contact be your only \"active\" contact, your check-ins will be disabled until the contact opts in or you add another active contact. Instructions will be sent to you on how to relay information to your contact explaining how they can opt-in again. This process is simple, the contact only has to respond with the word \"unstop\".</p>",
                    "description_text": " You will be sent a text notification informing you of the contact who has opted-out (e.g. replied \"stop\" to one of our notifications).     Should this contact be your only \"active\" contact, your check-ins will be disabled until the contact opts in or you add another active contact. Instructions will be sent to you on how to relay information to your contact explaining how they can opt-in again. This process is simple, the contact only has to respond with the word \"unstop\". ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        },
        {
            "id": 72000058090,
            "name": "Emergency Notes",
            "description": null,
            "visibility": 1,
            "created_at": "2021-10-22T01:07:24Z",
            "updated_at": "2021-10-22T01:07:24Z",
            "articles": [
                {
                    "id": 72000091199,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:58:15Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058090,
                    "title": "What are \"Emergency Notes\"?",
                    "updated_at": "2021-12-29T02:44:16Z",
                    "description": "<p dir=\"ltr\">Emergency Notes are details you provide for us to share with your Emergency Contacts should you fail to respond to our check-ins. These notes can relay helpful information your contacts can use to provide aid to you should you be in a situation needing somebody else's help.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Additionally, you can share these notes as needed via text message or the I'm Okay app to one of your emergency contacts or to another person via phone number.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\"><strong dir=\"ltr\">Example Uses:</strong></p><ul><li dir=\"ltr\">Your flight is delayed and you need to quickly inform a friend on how to feed your dog who is left home alone.<br><br></li><li dir=\"ltr\">You haven't responded to one of our check-ins because you were in an accident. You've provided information in your Medical Notes that you're allergic to some medications. Your emergency contacts can relay this information to your care provider.<br><br></li><li dir=\"ltr\">You're on vacation but forgot something, and need to quickly relay information on how to access/secure your home while you're away.</li></ul>",
                    "description_text": " Emergency Notes are details you provide for us to share with your Emergency Contacts should you fail to respond to our check-ins. These notes can relay helpful information your contacts can use to provide aid to you should you be in a situation needing somebody else's help.     Additionally, you can share these notes as needed via text message or the I'm Okay app to one of your emergency contacts or to another person via phone number.     Example Uses:   Your flight is delayed and you need to quickly inform a friend on how to feed your dog who is left home alone.    You haven't responded to one of our check-ins because you were in an accident. You've provided information in your Medical Notes that you're allergic to some medications. Your emergency contacts can relay this information to your care provider.    You're on vacation but forgot something, and need to quickly relay information on how to access/secure your home while you're away.  ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091200,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:59:40Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058090,
                    "title": "What types of Emergency Notes can I provide?",
                    "updated_at": "2021-10-22T01:59:40Z",
                    "description": "<p dir=\"ltr\">I'm Okay has pre-formatted templates to help you quickly add emergency notes for:</p><ul><li dir=\"ltr\">Your Medical Information</li><li dir=\"ltr\">Family and Child Care</li><li dir=\"ltr\">Pet Care</li><li dir=\"ltr\">Property Access and Care</li></ul><p dir=\"ltr\">Additionally, you can provide as many other notes as you need.</p>",
                    "description_text": " I'm Okay has pre-formatted templates to help you quickly add emergency notes for:   Your Medical Information  Family and Child Care  Pet Care  Property Access and Care   Additionally, you can provide as many other notes as you need. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091201,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:01:15Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058090,
                    "title": "Who can see my Emergency Notes?",
                    "updated_at": "2021-10-22T02:09:07Z",
                    "description": "<p dir=\"ltr\">Your emergency notes can only be seen under two conditions:</p><ul><li dir=\"ltr\">You haven't responded to a check-in and your emergency contacts have been sent an alert.</li><li dir=\"ltr\">You have manually sent one or more notes to another person.</li></ul><p dir=\"ltr\"><br></p><p dir=\"ltr\">Access to your emergency notes is <a href=\"https://support.imokay.me/en/support/solutions/articles/72000091203\">secured via text-based authentication</a>.</p>",
                    "description_text": " Your emergency notes can only be seen under two conditions:   You haven't responded to a check-in and your emergency contacts have been sent an alert.  You have manually sent one or more notes to another person.      Access to your emergency notes is secured via text-based authentication. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091203,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:07:36Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058090,
                    "title": "How is access to my Emergency Notes secured?",
                    "updated_at": "2021-12-29T02:45:10Z",
                    "description": "<p data-identifyelement=\"182\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\">Your emergency notes can only be seen under two conditions:</p><ul data-identifyelement=\"183\" style=\"box-sizing: border-box; margin-bottom: 4px; margin-left: 0px; padding: 0px 0px 0px 40px; line-height: 17px; list-style: disc;\"><li data-identifyelement=\"184\" dir=\"ltr\" style=\"box-sizing: border-box; font-size: 13px; line-height: 18px; margin-bottom: 0px; margin-left: 0px; word-break: normal; overflow-wrap: break-word;\">You haven't responded to a check-in and your emergency contacts have been sent an alert.</li><li data-identifyelement=\"185\" dir=\"ltr\" style=\"box-sizing: border-box; font-size: 13px; line-height: 18px; margin-bottom: 0px; margin-left: 0px; word-break: normal; overflow-wrap: break-word;\">You have manually sent one or more notes to another person.</li></ul><p data-identifyelement=\"186\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\"><br></p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\">Regardless of how your emergency notes are sent, there are measures in place to prevent unauthorized access.</p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\"><br></p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\">The first time your notes are viewed by one of your contacts (or another recipient if you sent them manually), your notes are displayed immediately from a customized, secure link sent to their phone.</p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\"><br></p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\">For any additional views of your notes, a confirmation code is sent to the recipient's phone that must be entered in order to view any of your information. This confirmation protects your information should any of the secure links sent to your contacts be shared on the internet, forwarded to other people, etc.</p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\"><br></p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\">If you are on active alert (you haven't replied to a check-in), your notes will immediately become unviewable once you respond, and let us know you're okay.</p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\"><br></p><p data-identifyelement=\"186\" dir=\"ltr\" style=\"box-sizing: border-box; margin-bottom: 0px; margin-left: 0px; font-size: 13px; line-height: 18px; word-break: normal; overflow-wrap: break-word;\">If you manually shared your emergency notes, you can revoke access to them at any time using the app.</p>",
                    "description_text": " Your emergency notes can only be seen under two conditions:   You haven't responded to a check-in and your emergency contacts have been sent an alert.  You have manually sent one or more notes to another person.      Regardless of how your emergency notes are sent, there are measures in place to prevent unauthorized access.     The first time your notes are viewed by one of your contacts (or another recipient if you sent them manually), your notes are displayed immediately from a customized, secure link sent to their phone.     For any additional views of your notes, a confirmation code is sent to the recipient's phone that must be entered in order to view any of your information. This confirmation protects your information should any of the secure links sent to your contacts be shared on the internet, forwarded to other people, etc.     If you are on active alert (you haven't replied to a check-in), your notes will immediately become unviewable once you respond, and let us know you're okay.     If you manually shared your emergency notes, you can revoke access to them at any time using the app. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091204,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:10:23Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058090,
                    "title": "Can I see if anyone has viewed my Emergency Notes?",
                    "updated_at": "2021-10-22T02:10:23Z",
                    "description": "<p dir=\"ltr\">Yes. All access to your emergency notes is recorded and logged so you can easily determine if anyone, and who, has viewed your information.</p>",
                    "description_text": " Yes. All access to your emergency notes is recorded and logged so you can easily determine if anyone, and who, has viewed your information. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000522921,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-02-15T05:44:16Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058090,
                    "title": "How many attachments can I add to my notes?",
                    "updated_at": "2022-02-15T05:44:16Z",
                    "description": "<p dir=\"ltr\">Each note may contain up to 10 attachments.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Please note that the total attachments from all your notes may not exceed 25MB in file size, and no attachment may exceed 5MB.</p>",
                    "description_text": " Each note may contain up to 10 attachments.     Please note that the total attachments from all your notes may not exceed 25MB in file size, and no attachment may exceed 5MB. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        },
        {
            "id": 72000058092,
            "name": "Privacy & Security",
            "description": null,
            "visibility": 1,
            "created_at": "2021-10-22T01:07:41Z",
            "updated_at": "2021-12-29T02:46:17Z",
            "articles": [
                {
                    "id": 72000091236,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:25:49Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058092,
                    "title": "How is my personal information protected?",
                    "updated_at": "2021-10-22T02:25:49Z",
                    "description": "<p dir=\"ltr\">We've taken every precaution to limit the potential of your personal information ever being exposed.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">The first step: We don't require any personal information aside from your phone number and email address. Your name, the names of your emergency contacts, etc. are all optional and can be first names or nicknames only.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">Your Emergency Notes are only accessible under certain conditions and, then, only by those you have authorized to view them. Additionally, text-based <a href=\"https://support.imokay.me/en/support/solutions/articles/72000091203\">authentication is required</a> to view your emergency notes.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">As a standard precaution, all your data is encrypted when stored so that even if our databases are exposed, the information contained within them can not be accessed without also having our encryption key.</p>",
                    "description_text": " We've taken every precaution to limit the potential of your personal information ever being exposed.     The first step: We don't require any personal information aside from your phone number and email address. Your name, the names of your emergency contacts, etc. are all optional and can be first names or nicknames only.     Your Emergency Notes are only accessible under certain conditions and, then, only by those you have authorized to view them. Additionally, text-based authentication is required to view your emergency notes.     As a standard precaution, all your data is encrypted when stored so that even if our databases are exposed, the information contained within them can not be accessed without also having our encryption key. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091193,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T01:21:13Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058092,
                    "title": "What data do you collect from me?",
                    "updated_at": "2021-12-29T02:46:02Z",
                    "description": "<p dir=\"ltr\">We record each time you reply to a check-in and retain this data for 7 days unless you fail to check-in. Your last-known location is logged when you use the app. You can opt out of sharing your location.&nbsp;</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">We do not share your personal information with any 3rd-parties, however, like for most sites and apps, your browser information may be shared with our analytics providers to help us measure page performance and other usage statistics. You're welcome to block these 3rd-party scripts and can learn more about them in our <a href=\"https://imokay.me/privacy\" rel=\"noreferrer\" target=\"_blank\">privacy policy</a>.</p>",
                    "description_text": " We record each time you reply to a check-in and retain this data for 7 days unless you fail to check-in. Your last-known location is logged when you use the app. You can opt out of sharing your location.      We do not share your personal information with any 3rd-parties, however, like for most sites and apps, your browser information may be shared with our analytics providers to help us measure page performance and other usage statistics. You're welcome to block these 3rd-party scripts and can learn more about them in our privacy policy. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000091235,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2021-10-22T02:21:00Z",
                    "category_id": 72000035784,
                    "folder_id": 72000058092,
                    "title": "How long is my check-in activity stored?",
                    "updated_at": "2021-12-29T02:46:52Z",
                    "description": "<p dir=\"ltr\">Unless you fail to respond to a check-in, I'mOkay.me only stores your check-in data for 7 days.</p><p dir=\"ltr\"><br></p><p dir=\"ltr\">If you fail to respond to a check-in, the previous week's check-in activity is retained in the event it may be helpful to your emergency contacts (if you are on an active alert, your contacts can view the date and time of your last check-in).</p>",
                    "description_text": " Unless you fail to respond to a check-in, I'mOkay.me only stores your check-in data for 7 days.     If you fail to respond to a check-in, the previous week's check-in activity is retained in the event it may be helpful to your emergency contacts (if you are on an active alert, your contacts can view the date and time of your last check-in). ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        },
        {
            "id": 72000326547,
            "name": "Pricing",
            "description": null,
            "visibility": 1,
            "created_at": "2022-01-06T04:10:09Z",
            "updated_at": "2022-01-06T04:10:09Z",
            "articles": [
                {
                    "id": 72000514013,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-06T04:17:47Z",
                    "category_id": 72000035784,
                    "folder_id": 72000326547,
                    "title": "How much does an I'mOkay.me subscription cost?",
                    "updated_at": "2022-01-06T04:17:47Z",
                    "description": "<p dir=\"ltr\">After your free trial period, your I'mOkay.me subscription will cost only $3.00 per month. There will never be an increase to the price of the subscription you signed up for, nor will you incur any additional fees during your subscription.&nbsp;</p>",
                    "description_text": " After your free trial period, your I'mOkay.me subscription will cost only $3.00 per month. There will never be an increase to the price of the subscription you signed up for, nor will you incur any additional fees during your subscription.  ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000514009,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-06T04:12:53Z",
                    "category_id": 72000035784,
                    "folder_id": 72000326547,
                    "title": "Why does an I'mOkay.me subscription cost money?",
                    "updated_at": "2022-01-06T04:12:53Z",
                    "description": "<p dir=\"ltr\">I'mOkay.me incurs expenses for both operating the application itself as well as charges from vendors and carriers for sending and receiving text messages. We provide our service at a cost that covers these expenses and other operational needs.</p>",
                    "description_text": " I'mOkay.me incurs expenses for both operating the application itself as well as charges from vendors and carriers for sending and receiving text messages. We provide our service at a cost that covers these expenses and other operational needs. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                },
                {
                    "id": 72000514012,
                    "type": 1,
                    "status": 2,
                    "agent_id": 72000453069,
                    "created_at": "2022-01-06T04:15:29Z",
                    "category_id": 72000035784,
                    "folder_id": 72000326547,
                    "title": "I can't afford an I'mOkay.me subscription, but I would really like to use your service. Are there any free alternatives?",
                    "updated_at": "2022-01-06T04:15:29Z",
                    "description": "<p dir=\"ltr\">We hope to offer a free subscription plan in the future. While the features may be limited for free plans (e.g. the frequency of check-ins sent to your phone, etc.) we hope to at least provide some level of support for those who wish to use our service but are unable to pay our current subscription fees.</p>",
                    "description_text": " We hope to offer a free subscription plan in the future. While the features may be limited for free plans (e.g. the frequency of check-ins sent to your phone, etc.) we hope to at least provide some level of support for those who wish to use our service but are unable to pay our current subscription fees. ",
                    "seo_data": {
                        "meta_title": "",
                        "meta_description": ""
                    },
                    "tags": [],
                    "attachments": [],
                    "cloud_files": [],
                    "thumbs_up": 0,
                    "thumbs_down": 0,
                    "hits": 0,
                    "feedback_count": 0
                }
            ]
        }
    ]
}